
namespace RioERP.Reports {
    export class B2CGstReportSummaryColumns {
        static columnsKey = 'Reports.B2CGstReportSummary';
    }
}